<template>
  <div class="main-content">
    <el-tag v-if="hasQueryTag" closable @close="clearQueryTag">{{
      queryTag
    }}</el-tag>
    <div>
      <ReleasesListPublic :releases="releases"></ReleasesListPublic>
    </div>
    <div class="paging">
      <el-pagination
        @current-change="handlePaginatorPageChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="paging.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { OopsErrorELMessage, ReleasesMixin } from "@/mixins";
import ReleasesListPublic from "@/components/ReleasesListPublic";
export default {
  name: "Releases",
  mixins: [OopsErrorELMessage, ReleasesMixin],
  components: {
    ReleasesListPublic
  },
  created() {
    this.listReleases();
  }
};
</script>
